import { createReducer, Action, on } from '@ngrx/store';
import {
    createFormGroupState,
    onNgrxForms,
    updateGroup,
    onNgrxFormsAction,
    SetValueAction,
    wrapReducerWithFormStateUpdate,
    setValue,
    validate,
    setErrors,
} from 'ngrx-forms';
import { IMobileVerificationState, MobileVerificationModel } from './state';
import { CheckMobileCodeResponseAction, ResetDataSavedAction, SendMobileCodeResponseAction, SetMobileAction } from './actions';
import { required } from 'ngrx-forms/validation';

const formName = 'mobileVerification';

const defaultState: IMobileVerificationState = {
    form: createFormGroupState(formName, new MobileVerificationModel()),
    message: '',
    dataSaved: false
};

const validateMobileVerification = updateGroup<MobileVerificationModel>({
    mobileCode: (state, parentState) => {
        if (!parentState.value.isMobileVerified) {
            state = validate(state, required)
        }
        else{
            state = setErrors(state, {})
        }
        return state;
    },
});

const reducer = createReducer(
    defaultState,
    onNgrxForms(),
    onNgrxFormsAction(SetValueAction, (state, _action) => {
        return state;
    }),
    on(SendMobileCodeResponseAction, (state, { data }) => {
        return {
            ...state,
            message: data.message,
            form: updateGroup<MobileVerificationModel>(state.form, { isMobileVerified: setValue(data.isMobileVerified) })
        };
    }),
    on(CheckMobileCodeResponseAction, (state,) => {
        return {
            ...state,
            dataSaved: true
        };
    }),
    on(SetMobileAction, (state, { mobile }) => {
        return {
            ...state,
            form: updateGroup<MobileVerificationModel>(state.form, { mobile: setValue(mobile) })
        }
    }),
    on(ResetDataSavedAction, (state) => {
        return {
            ...state,
            dataSaved: false
        }
    })
);

const editMobileVerificationDataFormState = wrapReducerWithFormStateUpdate(
    reducer,
    s => s.form,
    validateMobileVerification
)

export function mobileVerificationReducer(state: any | undefined, action: Action) {
    return editMobileVerificationDataFormState(state, action);
}
